<div class="dialog-content-wrapper" *ngIf="socio">
  <div class="detail-card">
    <div class="detail-header">
      <div class="header-icon">
        <i class="pi pi-user"></i>
      </div>
      <div class="header-info">
        <h2 class="detail-title">{{ socio.nmTrab }}</h2>
        <p class="detail-subtitle">{{ getTipoDocumento(socio.cpfTrab) }} · Matrícula {{ socio.matricula }}</p>
      </div>
    </div>

    <div class="info-section">
      <div class="section-title">
        <i class="pi pi-id-card"></i>
        <span>Informações do Sócio</span>
      </div>
      <div class="detail-grid">
        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-id-card"></i><span>CPF</span></div>
          <div class="detail-value">{{ formatarCpfCnpj(socio.cpfTrab) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar"></i><span>Data de Nascimento</span></div>
          <div class="detail-value">{{ formatarData(socio.dtNascto) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-venus-mars"></i><span>Sexo</span></div>
          <div class="detail-value">{{ getSexoDescricao(socio.sexo) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-heart"></i><span>Estado Civil</span></div>
          <div class="detail-value">{{ getEstadoCivilDescricao(socio.estCiv) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-graduation-cap"></i><span>Grau de Instrução</span></div>
          <div class="detail-value">{{ getGrauInstrucaoDescricao(socio.grauInstr) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-palette"></i><span>Raça/Cor</span></div>
          <div class="detail-value">{{ getRacaCorDescricao(socio.racaCor) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-phone"></i><span>Telefone</span></div>
          <div class="detail-value">{{ formatarTelefone(socio.fonePrinc) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-envelope"></i><span>E-mail</span></div>
          <div class="detail-value">{{ socio.emailPrinc || 'Não informado' }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-briefcase"></i><span>Cargo</span></div>
          <div class="detail-value">{{ socio.nmCargo || 'Não informado' }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar-plus"></i><span>Data de Início</span></div>
          <div class="detail-value">{{ formatarData(socio.dtInicio) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-dollar"></i><span>Valor Bruto</span></div>
          <div class="detail-value">{{ formatarValor(socio.vrSalFx) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-percentage"></i><span>Participação Societária</span></div>
          <div class="detail-value">{{ socio.participacaoSocietaria ? socio.participacaoSocietaria + '%' : 'Não informado' }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calculator"></i><span>INSS sobre Pró-Labore</span></div>
          <div class="detail-value">{{ formatarValor(socio.inssAproximado) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calculator"></i><span>IRRF sobre Pró-Labore</span></div>
          <div class="detail-value">{{ formatarValor(socio.baseInss) }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calculator"></i><span>Valor Líquido Pró-Labore</span></div>
          <div class="detail-value">{{ formatarValor(socio.contribuicaoInss) }}</div>
        </div>

        <div class="detail-item full-width">
          <div class="detail-label"><i class="pi pi-map-marker"></i><span>Endereço</span></div>
          <div class="detail-value">
            <span *ngIf="enderecoCompleto(socio) !== 'Não informado'" class="address-text">{{ enderecoCompleto(socio) }}</span>
            <span *ngIf="enderecoCompleto(socio) === 'Não informado'" class="no-data">Não informado</span>
          </div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-flag"></i><span>País de Nascimento</span></div>
          <div class="detail-value">{{ socio.paisNascto || 'Não informado' }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-calendar-times"></i><span>Data Início Validade</span></div>
          <div class="detail-value">{{ socio.dataInicioValidade || 'Não informado' }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-users"></i><span>Número de Dependentes</span></div>
          <div class="detail-value">{{ getNumeroDependentes() }}</div>
        </div>

        <div class="detail-item">
          <div class="detail-label"><i class="pi pi-link"></i><span>Duplo Vínculo</span></div>
          <div class="detail-value">{{ socio.duploVinculo ? 'Sim' : 'Não' }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
